import React, { useEffect, useState } from "react";
import GlobalSection from "./GlobalSection";
import { getPublicRequest } from "../api/auth";
import API_ROUTES from "../components/config/apiConfig";

const HomeGlobalSection = () => {
  const [categories, setCategories] = useState([]);
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    fetchMasterCategories();
  }, []);

  const fetchMasterCategories = async () => {
    try {
      const res = await getPublicRequest(API_ROUTES.GET_MASTER_CATEGORIES);

      const data = res.data || [];

      // ✅ buttons (top 3 names)
      const btns = data.slice(0, 3).map((item) => item.name);

      // ✅ categories section
      const cats = data.map((item) => ({
        title: item.name,
        img: item.image_url, // API se aa raha hoga
      }));

      setButtons(btns);
      setCategories(cats);

    } catch (err) {
      console.error("Error fetching master categories", err);
    }
  };

  return (
    <GlobalSection
      sectionTitle="Global Furniture Exporter"
      sectionSubtitle="Advanced Manufacturing & Quality Standards"
      sectionButtons={buttons}
      sectionCategories={categories}
    />
  );
};

export default HomeGlobalSection;